import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Heading, Text, Box, Flex } from 'mdlkit';
import { FocusShadowHyperlink } from 'components/shared/Styles';
import { AppCard, NextLinkButton } from '../shared';
import { event } from '../../lib/analytics';
import { REGISTRATION } from '../../constants/events';

const StyledNextLinkButton = styled(NextLinkButton)`
  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: ${({ theme }) => theme.space.sm}px;
  }
`;

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
  }
`;

interface Props {
  zip?: string;
}

const SkipBenefitCard: FunctionComponent<Props> = ({ zip }: Props) => (
  <AppCard>
    <Flex column>
      <Heading align="center" as="h1">
        Skip adding Coverage
      </Heading>
      <Text pt="md">
        If you don&apos;t have your information now, you can continue
        registering your account without adding a benefit provider. However, you
        will be charged the full cost of a visit until that information is
        added.
      </Text>
      <Text pt="md">You can add coverage before your visit.</Text>
      <StyledBox py="md" m="auto">
        <NextLinkButton
          size="large"
          data-testid="addBenefitBtn"
          href={`insurance?zip=${zip}`}
          onClick={() =>
            event({ action: 'abandon_skip', category: REGISTRATION })
          }
          data-track-event
          data-track={JSON.stringify({
            controlName: 'add-coverage-now-link',
            controlText: 'Add Coverage Now',
          })}
        >
          Add Coverage Now
        </NextLinkButton>
        <StyledNextLinkButton
          href="eligible-login"
          size="large"
          data-testid="noBenefitBtn"
          onClick={() =>
            event({
              action: 'confirm_skip_add_coverage_later',
              category: REGISTRATION,
            })
          }
          data-track-event
          data-track={JSON.stringify({
            controlName: 'confirm-add-coverage-later-link',
            controlText: 'Add Coverage Later',
          })}
        >
          Add Coverage Later
        </StyledNextLinkButton>
      </StyledBox>
      {zip && (
        <FocusShadowHyperlink
          m="auto"
          data-testid="noCoverageLink"
          href={`/affiliation-coverage?zip=${zip}`}
          onClick={() =>
            event({
              action: 'click_no_coverage',
              category: REGISTRATION,
              label: 'location',
              value: 'skip-benefit',
            })
          }
          data-track-event
          data-track={JSON.stringify({
            controlName: 'no-coverage-link',
            controlText: "I don't have coverage",
          })}
        >
          I don&apos;t have coverage
        </FocusShadowHyperlink>
      )}
    </Flex>
  </AppCard>
);

export default SkipBenefitCard;
